import FlexPaneViewState from '../store/schema/FlexPaneViewState';
import store from '../store/store';
import setAppPaneUnderlayVisibility from 'owa-application/lib/actions/setAppPaneUnderlayVisibility';
import { action, select } from 'satcheljs/lib/legacy';

export let flexPaneUnderlayKey = 'flexPane';

export interface SetFlexPaneUnderlayVisibilityState {
    store: FlexPaneViewState;
}

export default select<SetFlexPaneUnderlayVisibilityState>({
    store: () => store,
})(
    action('setFlexPaneVisibility')(function setFlexPaneVisibility(
        isShown: boolean,
        shrinkable?: boolean,
        state?: SetFlexPaneUnderlayVisibilityState
    ) {
        state.store.isShown = isShown;
        setAppPaneUnderlayVisibility(flexPaneUnderlayKey, isShown, shrinkable);
    })
);
